import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import CoursesView from "../views/CoursesView";
import i18n from "../../../i18n";
import { isJson } from "../../../utilities";
import {
  STEP_QUALIFICATION_CREATE,
  STEP_SESSION_CONTACT,
  STEP_SESSION_DETAILS,
  STEP_SESSION_VENUES,
  STEP_SESSION_VIEW,
  TAB_COURSE_CLASSIFICATIONS,
  TAB_COURSE_DETAILS,
  TAB_COURSE_QUALIFICATIONS,
  TAB_COURSE_SESSIONS,
  TRANSLATOR_UNASSIGNED,
} from "../../../constants";
import { route } from "../../../routes";
import {
  FormUtility,
  withCoursePortalApi,
  withRouter,
} from "cw-styleguide-react";
import withAuditApi from "../../../apis/withAuditApi";
import withAssets from "../../../components/hoc/withAssets";

class CoursesController extends Component {
  /**
   * constructor.
   * @param props
   */
  constructor(props) {
    super(props);

    // State.
    this.state = Object.assign(
      {
        inputLanguage: "en",
        formErrors: {},
        errorActiveField: null,
        errorActiveTab: null,
        errorActiveSessionStep: null,
        errorActiveSessionId: null,
        errorActiveQualificationStep: null,
        errorActiveQualificationId: null,
        modals: {
          bulkDelete: false,
          bulkArchive: false,
          bulkRollback: false,
          delete: false,
          archive: false,
          rollback: false,
        },
        isProcessing: false,
        loaded: false,
        messages: new Set(),
        redirect: null,
        selected: new Set(),
        reloadKey: Math.random(),
        query: "",
      },
      this.getInitialValues()
    );

    this.archiveCourse = this.archiveCourse.bind(this);
    this.rollbackCourse = this.rollbackCourse.bind(this);
    this.deleteCourse = this.deleteCourse.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleBulkCheckbox = this.handleBulkCheckbox.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.clearMessages = this.clearMessages.bind(this);
    this.clearSelected = this.clearSelected.bind(this);
    this.clearRedirect = this.clearRedirect.bind(this);
    this.handleSetInputLanguage = this.handleSetInputLanguage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSet = this.handleSet.bind(this);
    // this.handleScrollToElement = this.handleScrollToElement.bind(this);
    this.saveCourse = this.saveCourse.bind(this);
    this.loadCourse = this.loadCourse.bind(this);
    this.loadAudit = this.loadAudit.bind(this);
    this.clearAudit = this.clearAudit.bind(this);
    this.handleErrorClick = this.handleErrorClick.bind(this);
    this.handleClearActiveErrors = this.handleClearActiveErrors.bind(this);
    this.clearCourse = this.clearCourse.bind(this);
    this.resetInputLanguage = this.resetInputLanguage.bind(this);
    this.setReloadKey = this.setReloadKey.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.resetQuery = this.resetQuery.bind(this);
  }

  /**
   * getInitialValues
   */
  getInitialValues() {
    return {
      id: "",
      status: "",
      translatorAssigned: TRANSLATOR_UNASSIGNED,
      qaDate: "",

      title_en: "",
      title_cy: "",
      qualificationTitleId: "",
      qualificationTitleLabel: "",
      qualificationTitleLabel_en: "",
      qualificationTitleLabel_cy: "",
      mainProviderId: "",
      mainProviderLabel: "",
      abbreviatedTitle_en: "",
      abbreviatedTitle_cy: "",
      courseGroupId: "",
      courseGroupLabel: "",
      courseGroupType: "",
      courseGroupTypeId: "",
      summary_en: "",
      summary_cy: "",
      content_en: "",
      content_cy: "",
      programme: "",
      duration_en: "",
      duration_cy: "",
      entry_en: "",
      entry_cy: "",
      additionalDetails_en: "",
      additionalDetails_cy: "",
      enrolment_en: "",
      enrolment_cy: "",
      cost_en: "",
      cost_cy: "",
      languages: [],
      courseType: new Set(),
      reviewDate: "",

      sessions: [],
      sessionId: "1", // Set default session ID to 1 for inline validation error field keys on unsaved sessions (e.g. sessions.1.venues.1.id)
      startDate: "",
      startDetails_en: "",
      startDetails_cy: "",
      daysTimes_en: "",
      daysTimes_cy: "",
      studyMethodType: new Set(),
      studyMethodHours: new Set(),
      studyMethodTimes: new Set(),
      contactId: "",
      contactLabel: "",
      contacts: [],
      venueId: "",
      venueLabel: "",
      venueContactId: "",
      venueContactLabel: "",
      venues: [],

      qualificationId: "",
      qualificationLabel: "",
      qualifications: [],
      unknownQualifications: new Set(),
      manualQualificationId: "",
      qualificationTitle_en: "",
      qualificationTitle_cy: "",
      qualificationType: "",
      qualificationLevel: new Set(),
      awardingBody: "",
      manualQualifications: [],

      classificationId: "",
      classificationLabel: "",
      classifications: [],
    };
  }

  /**
   * clearContact
   */
  clearCourse() {
    this.setState(this.getInitialValues());
  }

  /**
   * resetInputLanguage
   */
  resetInputLanguage() {
    this.setState({
      inputLanguage: "en",
    });
  }

  /**
   * clearSelected
   */
  clearSelected() {
    this.setState({
      selected: new Set(),
    });
  }

  /**
   * clearMessages
   */
  clearMessages() {
    this.setState({
      messages: new Set(),
      formErrors: {},
      // errorActiveTab: null,
      // errorActiveSessionStep: null,
      // errorActiveSessionId: null,
      // errorActiveQualificationStep: null,
      // errorActiveQualificationId: null
    });
  }

  /**
   * clearRedirect
   */
  clearRedirect() {
    this.setState({
      redirect: null,
    });
  }

  /**
   * Set a new reload key forcing a page refresh.
   */
  setReloadKey() {
    this.setState({
      reloadKey: Math.random(),
    });
  }

  /**
   * toggleModal
   * @param id
   */
  toggleModal(ids, visiblity) {
    const modals = { ...this.state.modals };

    // loop through the ids.
    ids.forEach((id) => {
      modals[id] = visiblity;
    });

    this.setState({
      modals: modals,
    });
  }

  /**
   * handleBulkCheckbox
   * @param event
   */
  handleBulkCheckbox(event) {
    const selected = this.state.selected;
    if (selected.has(event.target.value)) {
      selected.delete(event.target.value);
    } else {
      selected.add(event.target.value);
    }
    this.setState({
      selected: selected,
    });
  }

  /**
   * handleSelectAll
   * @param ids
   */
  handleSelectAll(ids) {
    let selected = this.state.selected;

    selected = selected.size < ids.length ? new Set(ids) : new Set();

    this.setState({
      selected: selected,
    });
  }

  /**
   * archiveCourse
   * @param ids
   */
  archiveCourse(ids, redirect = null) {
    this.setState({
      isProcessing: true,
    });

    this.props.coursePortalApiArchiveCourse(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.courseIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.archive.singular",
              { count: response.data.courseIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.archive.plural",
              { count: response.data.courseIds.length }
            ),
          });
        }

        this.setState({
          isProcessing: false,
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });
        this.toggleModal(["archive", "bulkArchive"], false);
      },
      (error) => {
        this.toggleModal(["archive", "bulkArchive"], false);

        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          isProcessing: false,
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * Rollback a set of courses.
   * @param ids
   */
  rollbackCourse(ids, redirect = null) {
    this.setState({
      isProcessing: true,
    });

    this.props.coursePortalApiDeleteDraft(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        // Display a plural or singular message on successful deletion.
        if (response.data.courseIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.rollback.singular",
              { count: response.data.courseIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.rollback.plural",
              { count: response.data.courseIds.length }
            ),
          });
        }

        this.setState({
          isProcessing: false,
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });
        this.toggleModal(["rollback", "bulkRollback"], false);
      },
      (error) => {
        this.toggleModal(["rollback", "bulkRollback"], false);

        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          isProcessing: false,
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  /**
   * courseDelete
   * @param courses
   * @param callback
   */
  deleteCourse(ids, redirect = null) {
    this.setState({
      isProcessing: true,
    });

    this.props.coursePortalApiDeleteCourse(
      ids,
      i18n.language,
      (response) => {
        let messages = new Set();

        if (response.data.courseIds.length === 1) {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.delete.singular",
              { count: response.data.courseIds.length }
            ),
          });
        } else {
          messages.add({
            type: "positive",
            message: i18n.t(
              "local:view.courses.manage.messages.delete.plural",
              { count: response.data.courseIds.length }
            ),
          });
        }

        this.setState({
          isProcessing: false,
          formErrors: [],
          messages: messages,
          selected: new Set(),
          redirect: redirect,
          reloadKey: Math.random(),
        });
        this.toggleModal(["delete", "bulkDelete"], false);
      },
      (error) => {
        this.toggleModal(["delete", "bulkDelete"], false);

        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          isProcessing: false,
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  handleSetInputLanguage(e) {
    e.preventDefault();

    this.setState({
      inputLanguage: e.target.value,
    });
  }

  handleChange(e) {
    let values = { ...this.state };
    let changedValue = e.target.value;

    if (e.target.type === "checkbox") {
      if (changedValue === "") {
        values[e.target.name].clear();
      } else if (values[e.target.name].has(changedValue)) {
        values[e.target.name].delete(changedValue);
      } else {
        values[e.target.name].add(changedValue);
      }
    } else {
      if (
        (typeof changedValue === "string" || changedValue instanceof String) &&
        isNaN(changedValue) &&
        isJson(changedValue)
      ) {
        changedValue = JSON.parse(changedValue);
      }

      values[e.target.name] = changedValue;
    }

    this.setState(values);
  }

  // https://stackoverflow.com/questions/10855908/how-to-overload-functions-in-javascript
  handleSet(key, value) {
    if (arguments.length === 0) {
      // .data()
      // no args passed, return all keys/values in an object
    } else if (typeof key === "string") {
      // first arg is a string, look at type of second arg
      if (typeof value !== "undefined") {
        // .data("key", value)
        // set the value for a particular key
        this.setState({
          [key]: value,
        });
      } else {
        // .data("key")
        // retrieve a value for a key
      }
    } else if (typeof key === "object") {
      // .data(object)
      // set all key/value pairs from this object
      this.setState(key);
    } else {
      // unsupported arguments passed
    }
  }

  /**
   * loadAudit
   * @param id
   */
  loadAudit(id) {
    this.props.auditApiGetAudit(
      id,
      "coursePortal",
      i18n.language,
      (response) => {
        this.setState({
          audit: response.data,
        });
      },
      (error) => {
        this.setState({
          audit: false,
        });
      }
    );
  }

  clearAudit() {
    this.setState({
      audit: false,
    });
  }

  /**
   * loadCourse
   * @param id
   */
  loadCourse(id, duplicate = false) {
    this.setState({
      loaded: false,
    });

    this.props.coursePortalApiGetCourse(
      id,
      i18n.language,
      (response) => {
        // Assign unique identifier to session entities.
        response.data.sessions.forEach((session) => {
          session.uuid = uuidv4();
        });

        // Assign unique identifier to manual qualification entities.
        response.data.manualQualifications.forEach((session) => {
          session.uuid = uuidv4();
        });

        this.setState({
          id: duplicate ? "" : response.data.id,
          status: duplicate ? null : response.data.status,
          translatorAssigned: response.data.translatorAssigned,
          qaDate: response.data.qaDate,

          title_en: response.data.title.en,
          title_cy: response.data.title.cy,
          mainProviderId: response.data.courseGroup.mainProvider.atlasAccountId,
          mainProviderLabel:
            response.data.courseGroup.mainProvider.cw_courseprovidername,
          abbreviatedTitle_en: response.data.abbreviatedTitle.en,
          abbreviatedTitle_cy: response.data.abbreviatedTitle.cy,
          courseGroupId: response.data.courseGroup.id,
          courseGroupLabel: response.data.courseGroup.name,
          courseGroupType: response.data.courseGroup.type,
          courseGroupTypeId: response.data.courseGroup.type,
          summary_en: response.data.summary.en,
          summary_cy: response.data.summary.cy,
          content_en: response.data.content.en,
          content_cy: response.data.content.cy,
          programme: response.data.programme,
          duration_en: response.data.duration.en,
          duration_cy: response.data.duration.cy,
          entry_en: response.data.entry.en,
          entry_cy: response.data.entry.cy,
          additionalDetails_en: response.data.additionalDetails.en,
          additionalDetails_cy: response.data.additionalDetails.cy,
          enrolment_en: response.data.enrolment.en,
          enrolment_cy: response.data.enrolment.cy,
          cost_en: response.data.cost.en,
          cost_cy: response.data.cost.cy,
          languages: response.data.languages,
          courseType: new Set(response.data.courseType),
          reviewDate: response.data.reviewDate,

          sessions: response.data.sessions || [],

          qualifications: response.data.qualifications || [],
          unknownQualifications: response.data.qualificationUnknown
            ? new Set(["1"])
            : new Set(),
          manualQualifications: response.data.manualQualifications || [],

          classifications: response.data.classifications || [],

          loaded: true,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);
        this.setState({
          formErrors: errors.formErrors,
          messages: errors.messages,
          loaded: false,
        });
      }
    );
  }

  saveCourse(status) {
    this.setState({
      isProcessing: true,
    });

    let payload = {
      // id: '',
      status: status,
      translatorAssigned: this.state.translatorAssigned,
      // qaDate: '',

      title: {
        en: this.state.title_en,
        cy: this.state.title_cy,
      },
      abbreviatedTitle: {
        en: this.state.abbreviatedTitle_en,
        cy: this.state.abbreviatedTitle_cy,
      },
      courseGroup: {
        id: this.state.courseGroupId,
      },
      summary: {
        en: this.state.summary_en,
        cy: this.state.summary_cy,
      },
      content: {
        en: this.state.content_en,
        cy: this.state.content_cy,
      },
      programme: this.state.programme,
      duration: {
        en: this.state.duration_en,
        cy: this.state.duration_cy,
      },
      entry: {
        en: this.state.entry_en,
        cy: this.state.entry_cy,
      },
      additionalDetails: {
        en: this.state.additionalDetails_en,
        cy: this.state.additionalDetails_cy,
      },
      enrolment: {
        en: this.state.enrolment_en,
        cy: this.state.enrolment_cy,
      },
      cost: {
        en: this.state.cost_en,
        cy: this.state.cost_cy,
      },
      languages: this.state.languages,
      courseType: [...this.state.courseType],
      reviewDate: this.state.reviewDate,

      sessions: this.state.sessions,

      qualifications: this.state.qualifications.map((qualification) => ({
        qwApprovalDesignationNo: qualification.qwApprovalDesignationNo,
      })),
      qualificationUnknown: this.state.unknownQualifications.has("1")
        ? true
        : false,
      manualQualifications: this.state.manualQualifications,

      classifications: this.state.classifications.map((classification) => ({
        id: classification.id,
      })),
    };

    payload.sessions.forEach((session, index) => {
      session.id = index + 1;
    });

    payload.manualQualifications.forEach((manualQualification, index) => {
      manualQualification.id = index + 1;
    });

    // Remove qualifications if unkonwn qualifications is checked.
    if (this.state.unknownQualifications.size === 1) {
      payload.qualifications = [];
    }

    // Add the ID if it exists to facilitate editing.
    if (this.state.id) {
      payload.id = this.state.id;
    }

    this.props.coursePortalApiPostCourse(
      payload,
      i18n.language,
      (response) => {
        let messages = new Set();

        messages.add({
          type: "positive",
          message: i18n.t(
            "local:view.courses.status." + response.data.status + ".success",
            { id: response.data.id }
          ),
        });
        this.setState({
          isProcessing: false,
          formErrors: [],
          redirect: route("coursesManage") + this.state.query,
          messages: messages,
        });
      },
      (error) => {
        let errors = FormUtility.processServerErrors(error, i18n);

        this.setState({
          isProcessing: false,
          formErrors: errors.formErrors,
          messages: errors.messages,
        });
      }
    );
  }

  handleErrorClick(e, field) {
    e.preventDefault();
    // // Find instances of [] in field.
    // const matchedIndexes = field.match(/\[(.*?)\]/);

    this.setState({
      errorActiveField: field,
    });

    // let index = null;
    // if (matchedIndexes) {
    //   // Save the index associated with the error.
    //   index = matchedIndexes[1];

    //   // Strip index from field string.
    //   field = field.replace(matchedIndexes[0], '');
    // }

    field = field.split(".");

    // Save the index.
    // field.forEach(fragment => {
    //   if (!isNaN(fragment)) {
    //     index = parseInt(fragment);
    //   }
    // });

    const index = parseInt(field.find((fragment) => !isNaN(fragment))) || null;

    // Remove indexes from field name.
    field = field.filter((fragment) => isNaN(fragment));
    field = field.join(".");

    // Clear active errors before reassignment.
    // this.setState({
    //   errorActiveTab: null,
    //   errorActiveSessionStep: null,
    //   errorActiveSessionId: null,
    //   errorActiveQualificationStep: null,
    //   errorActiveQualificationId: null,

    //   inputLanguage: field.includes('_cy') ? 'cy' : 'en'
    // });

    switch (field) {
      case "title_en":
      case "title_cy":
      case "abbreviatedTitle_en":
      case "abbreviatedTitle_cy":
      case "courseGroup.id":
      case "reviewDate":
      case "summary_en":
      case "summary_cy":
      case "content_en":
      case "content_cy":
      case "programme":
      case "entry_en":
      case "entry_cy":
      case "enrolment_en":
      case "enrolment_cy":
      case "cost_en":
      case "cost_cy":
        this.setState({
          errorActiveTab: TAB_COURSE_DETAILS,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "sessions":
        if (index) {
          this.setState({
            errorActiveTab: TAB_COURSE_SESSIONS,
            errorActiveSessionStep: STEP_SESSION_DETAILS,
            errorActiveSessionId: index,

            inputLanguage: field.includes("_cy") ? "cy" : "en",
          });
        } else {
          this.setState({
            errorActiveTab: TAB_COURSE_SESSIONS,
            errorActiveSessionStep: STEP_SESSION_VIEW,
            errorActiveSessionId: index,

            inputLanguage: field.includes("_cy") ? "cy" : "en",
          });
        }
        break;

      case "sessions.startDate":
      case "sessions.startDetails_en":
      case "sessions.startDetails_cy":
      case "sessions.daysTimes_en":
      case "sessions.daysTimes_cy":
      case "sessions.studyMethodType":
        this.setState({
          errorActiveTab: TAB_COURSE_SESSIONS,
          errorActiveSessionStep: STEP_SESSION_DETAILS,
          errorActiveSessionId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "sessions.contact.id":
        this.setState({
          errorActiveTab: TAB_COURSE_SESSIONS,
          errorActiveSessionStep: STEP_SESSION_CONTACT,
          errorActiveSessionId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "sessions.venues.id":
        this.setState({
          errorActiveTab: TAB_COURSE_SESSIONS,
          errorActiveSessionStep: STEP_SESSION_VENUES,
          errorActiveSessionId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "manualQualifications.title_en":
      case "manualQualifications.title_cy":
      case "manualQualifications.qualificationType":
        this.setState({
          errorActiveTab: TAB_COURSE_QUALIFICATIONS,
          errorActiveQualificationStep: STEP_QUALIFICATION_CREATE,
          errorActiveQualificationId: index,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      case "classifications.id":
        this.setState({
          errorActiveTab: TAB_COURSE_CLASSIFICATIONS,

          inputLanguage: field.includes("_cy") ? "cy" : "en",
        });
        break;

      default:
        break;
    }

    // this.setState({
    //   inputLanguage: field.includes('_cy') ? 'cy' : 'en'
    // });
  }

  handleClearActiveErrors() {
    // Clear active errors before reassignment.
    this.setState({
      errorActiveField: null,
      errorActiveTab: null,
      errorActiveSessionStep: null,
      errorActiveSessionId: null,
      errorActiveQualificationStep: null,
      errorActiveQualificationId: null,
    });
  }

  // handleScrollToElement(id) {
  //   const element = document.getElementById(id);

  //   if (element) {
  //     element.scrollIntoView();
  //   }

  //   this.setState({
  //     errorActiveTab: null,
  //     // errorActiveQualificationStep: null,
  //     // errorActiveQualificationId: null
  //   });
  // }

  /**
   * setQuery
   * @param value
   */
  setQuery(value) {
    console.log("setting query", value);
    this.setState({
      query: value,
    });
  }

  /**
   * resetQuery
   */
  resetQuery() {
    this.setState({
      query: "",
    });
  }

  render() {
    return (
      <CoursesView
        {...this.state}
        archiveCourse={this.archiveCourse}
        rollbackCourse={this.rollbackCourse}
        deleteCourse={this.deleteCourse}
        toggleModal={this.toggleModal}
        handleBulkCheckbox={this.handleBulkCheckbox}
        handleSelectAll={this.handleSelectAll}
        clearMessages={this.clearMessages}
        clearSelected={this.clearSelected}
        clearRedirect={this.clearRedirect}
        handleSetInputLanguage={this.handleSetInputLanguage}
        handleChange={this.handleChange}
        handleSet={this.handleSet}
        // handleScrollToElement={this.handleScrollToElement}
        saveCourse={this.saveCourse}
        loadCourse={this.loadCourse}
        loadAudit={this.loadAudit}
        clearAudit={this.clearAudit}
        clearCourse={this.clearCourse}
        resetInputLanguage={this.resetInputLanguage}
        handleErrorClick={this.handleErrorClick}
        handleClearActiveErrors={this.handleClearActiveErrors}
        setReloadKey={this.setReloadKey}
        setQuery={this.setQuery}
        resetQuery={this.resetQuery}
      />
    );
  }
}

export default withRouter(
  withAssets(
    withAuditApi(process.env)(
      withCoursePortalApi(process.env)(CoursesController)
    )
  )
);
